'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var tslib = require('tslib');
require('../../utils/getThemeProp.js');
require('../../utils/colors.js');
require('../../utils/dates.js');
require('../../utils/numbers.js');
require('../../utils/PrintComponentGenerator/PrintComponentGenerator.js');
require('../../utils/strings.js');
var infiniteScrollCheckStateManager = require('../../utils/infiniteScrollCheckStateManager/infiniteScrollCheckStateManager.js');
require('../../utils/pairedTableComponentGenerator/pairedTableComponentGenerator.js');
require('../../utils/safeFetch.js');
require('../../utils/dom.js');
var InputCheckbox = require('../../inputs/InputCheckbox/InputCheckbox.js');
var InfiniteScrollTable = require('../InfiniteScrollTable/InfiniteScrollTable.js');

var InfiniteScrollTableWithChecks = function (props) {
    var _a = props.defaultAllChecked, defaultAllChecked = _a === void 0 ? false : _a, _b = props.defaultCheckedValues, defaultCheckedValues = _b === void 0 ? [] : _b, checkAllReporter = props.checkAllReporter, headCells = props.headCells, generateRow = props.generateRow, fetchMore = props.fetchMore;
    var _c = React.useState(false), allChecked = _c[0], setAllChecked = _c[1];
    var _d = React.useState(false), allSelected = _d[0], setAllSelected = _d[1];
    var _e = React.useState({}), selectedValues = _e[0], setSelectedValues = _e[1];
    React.useEffect(function () {
        var includeExcludeValues = Object.keys(selectedValues).filter(function (sv) { return selectedValues[sv] !== allSelected; });
        checkAllReporter(allSelected, includeExcludeValues);
    }, [allSelected, selectedValues]);
    var managedCheckReporter = function (allCheckedValue, allSelectedValue, selectedValuesValue) {
        setAllChecked(allCheckedValue);
        setAllSelected(allSelectedValue);
        setSelectedValues(tslib.__assign({}, selectedValuesValue));
    };
    var manager = infiniteScrollCheckStateManager({
        defaultAllChecked: defaultAllChecked,
        defaultCheckedValues: defaultCheckedValues,
        reporter: managedCheckReporter,
    });
    var getHeadCells = function () {
        return tslib.__spreadArrays([
            React__default.createElement(InputCheckbox, { onChange: manager.setAllChecked, controlled: true, initiallyChecked: allChecked })
        ], headCells);
    };
    var generateCheckedRow = function (row) {
        return tslib.__spreadArrays([
            React__default.createElement(InputCheckbox, { onChange: function (selected) { return manager.selectValue(row.id, selected); }, controlled: true, initiallyChecked: selectedValues[row.id] })
        ], generateRow(row));
    };
    var handleFetchMore = function (page) {
        return fetchMore(page).then(function (result) {
            manager.addMoreValues(result.data.map(function (d) { return d.id; }));
            return result;
        });
    };
    return (React__default.createElement(InfiniteScrollTable, tslib.__assign({}, props, { fetchMore: handleFetchMore, headCells: getHeadCells(), generateRow: generateCheckedRow })));
};

module.exports = InfiniteScrollTableWithChecks;
